<router-outlet></router-outlet>
<ng4-loading-spinner> </ng4-loading-spinner>
